import { render, staticRenderFns } from "./treaty.vue?vue&type=template&id=22866a80&scoped=true&"
import script from "./treaty.vue?vue&type=script&lang=js&"
export * from "./treaty.vue?vue&type=script&lang=js&"
import style0 from "./treaty.vue?vue&type=style&index=0&id=22866a80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22866a80",
  null
  
)

export default component.exports